import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../dashboard/components/Header';
import Sidebar from '../dashboard/components/Sidebar';
import PurchaseOrdersList from './components/PurchaseOrdersList';
import PurchaseOrderForm from './components/PurchaseOrderForm';
import ReceptionsList from './components/ReceptionsList';
import ReceptionForm from './components/ReceptionForm';
import SuggestedOrders from './components/SuggestedOrders';
import SupplierInvoicesList from './components/SupplierInvoicesList';
import SupplierInvoiceForm from './components/SupplierInvoiceForm';
import PaymentForm from './components/PaymentForm';
import PaymentDashboard from './components/PaymentDashboard';

export default function PurchaseOrdersPage() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('orders');
  const [showOrderForm, setShowOrderForm] = useState(false);
  const [showReceptionForm, setShowReceptionForm] = useState(false);
  const [showInvoiceForm, setShowInvoiceForm] = useState(false);
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const [editingOrder, setEditingOrder] = useState(null);
  const [editingInvoice, setEditingInvoice] = useState(null);
  const [selectedOrderForReception, setSelectedOrderForReception] = useState(null);
  const [selectedInvoiceForPayment, setSelectedInvoiceForPayment] = useState(null);
  const [showOrderDetails, setShowOrderDetails] = useState(false);
  const [showInvoiceDetails, setShowInvoiceDetails] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const navigate = useNavigate();

  const handleAddOrder = () => {
    setEditingOrder(null);
    setShowOrderForm(true);
  };

  const handleEditOrder = (order: any) => {
    setEditingOrder(order);
    setShowOrderForm(true);
  };

  const handleCloseForm = () => {
    setShowOrderForm(false);
    setEditingOrder(null);
  };

  const handleReceiveOrder = (order: any) => {
    setSelectedOrderForReception(order);
    setShowReceptionForm(true);
  };

  const handleCloseReceptionForm = () => {
    setShowReceptionForm(false);
    setSelectedOrderForReception(null);
  };

  const handleSaveReception = (receptionData: any) => {
    console.log('Réception enregistrée:', receptionData);
    alert('Réception enregistrée avec succès! Le stock a été mis à jour.');
    handleCloseReceptionForm();
  };

  const handleViewReceptionDetails = (reception: any) => {
    console.log('Voir détails réception:', reception);
  };

  const handleViewOrderDetails = (order: any) => {
    setSelectedOrder(order);
    setShowOrderDetails(true);
  };

  const handleCloseOrderDetails = () => {
    setShowOrderDetails(false);
    setSelectedOrder(null);
  };

  // Gestion des factures fournisseurs
  const handleAddInvoice = () => {
    setEditingInvoice(null);
    setShowInvoiceForm(true);
  };


  const handleEditInvoice = (invoice: any) => {
  // 🔴 FERMER LE DÉTAIL
  setShowInvoiceDetails(false);
  setSelectedInvoice(null);

  // ✅ OUVRIR LE FORMULAIRE
  setEditingInvoice(invoice);
  setShowInvoiceForm(true);
};

  const handleCloseInvoiceForm = () => {
    setShowInvoiceForm(false);
    setEditingInvoice(null);
  };

  const handleSaveInvoice = (invoiceData: any) => {
    console.log('Facture enregistrée:', invoiceData);
    alert('Facture fournisseur enregistrée avec succès!');
    handleCloseInvoiceForm();
  };

  const handleViewInvoiceDetails = (invoice: any) => {
    setSelectedInvoice(invoice);
    setShowInvoiceDetails(true);
  };

  const handleCloseInvoiceDetails = () => {
    setShowInvoiceDetails(false);
    setSelectedInvoice(null);
  };

  // Gestion des règlements
  const handleAddPayment = (invoice: any) => {
  // 🔴 FERMER LE DÉTAIL
  setShowInvoiceDetails(false);
  setSelectedInvoice(null);

  // ✅ OUVRIR LE PAIEMENT
  setSelectedInvoiceForPayment(invoice);
  setShowPaymentForm(true);
};


  const handleClosePaymentForm = () => {
    setShowPaymentForm(false);
    setSelectedInvoiceForPayment(null);
  };

  const handleSavePayment = (updatedInvoice: any) => {
    console.log('Règlement enregistré:', updatedInvoice);
    alert('Règlement enregistré avec succès! Le statut de la facture a été mis à jour.');
    handleClosePaymentForm();
  };

  const getTabTitle = () => {
    switch (activeTab) {
      case 'orders': return 'Bons de Commande';
      case 'receptions': return 'Réceptions';
      case 'suggestions': return 'Suggestions';
      case 'invoices': return 'Factures Fournisseurs';
      case 'payments': return 'Tableau de Bord des Échéances';
      default: return 'Gestion des Achats';
    }
  };

  const getTabDescription = () => {
    switch (activeTab) {
      case 'orders': return 'Gestion des commandes fournisseurs';
      case 'receptions': return 'Suivi des réceptions de marchandises';
      case 'suggestions': return 'Suggestions automatiques de réapprovisionnement';
      case 'invoices': return 'Gestion des factures et rapprochements';
      case 'payments': return 'Suivi des échéances et règlements';
      default: return 'Gestion complète des achats et approvisionnements';
    }
  };

  const showAddButton = () => {
    return !showOrderForm && !showReceptionForm && !showOrderDetails && 
           !showInvoiceForm && !showPaymentForm && !showInvoiceDetails &&
           (activeTab === 'orders' || activeTab === 'invoices');
  };

  const getAddButtonText = () => {
    switch (activeTab) {
      case 'orders': return 'Nouvelle Commande';
      case 'invoices': return 'Nouvelle Facture';
      default: return 'Nouveau';
    }
  };

  const handleAddButtonClick = () => {
    switch (activeTab) {
      case 'orders': handleAddOrder(); break;
      case 'invoices': handleAddInvoice(); break;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
      
      <div className="flex">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        
        <main className="flex-1 p-4 sm:p-6 lg:ml-64 pt-20 sm:pt-24">
          <div className="max-w-7xl mx-auto">
            <div className="mb-6 sm:mb-8 flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <button
                  onClick={() => navigate('/dashboard')}
                  className="flex items-center justify-center w-10 h-10 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer"
                  title="Retour au tableau de bord"
                >
                  <i className="ri-arrow-left-line text-xl text-gray-600"></i>
                </button>
                <div>
                  <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-1 sm:mb-2">{getTabTitle()}</h1>
                  <p className="text-sm sm:text-base text-gray-600">{getTabDescription()}</p>
                </div>
              </div>
              
              {showAddButton() && (
                <button
                  onClick={handleAddButtonClick}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer flex items-center space-x-2"
                >
                  <i className="ri-add-line text-lg"></i>
                  <span className="hidden sm:inline">{getAddButtonText().split(' ')[0]}</span>
                  <span>{getAddButtonText().split(' ').slice(1).join(' ')}</span>
                </button>
              )}
            </div>

            {/* Onglets de navigation */}
            {!showOrderForm && !showReceptionForm && !showOrderDetails && 
             !showInvoiceForm && !showPaymentForm && !showInvoiceDetails && (
              <div className="mb-4 sm:mb-6">
                <div className="border-b border-gray-200 overflow-x-auto">
                  <nav className="-mb-px flex space-x-2 sm:space-x-8 min-w-max">
                    <button
                      onClick={() => setActiveTab('orders')}
                      className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap flex items-center space-x-1 sm:space-x-2 ${
                        activeTab === 'orders'
                          ? 'border-blue-500 text-blue-600'
                          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                      }`}
                    >
                      <i className="ri-file-list-3-line"></i>
                      <span className="hidden sm:inline">Bons de </span>
                      <span>Commande</span>
                    </button>
                    <button
                      onClick={() => setActiveTab('receptions')}
                      className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap flex items-center space-x-1 sm:space-x-2 ${
                        activeTab === 'receptions'
                          ? 'border-blue-500 text-blue-600'
                          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                      }`}
                    >
                      <i className="ri-truck-line"></i>
                      <span>Réceptions</span>
                    </button>
                    <button
                      onClick={() => setActiveTab('suggestions')}
                      className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap flex items-center space-x-1 sm:space-x-2 ${
                        activeTab === 'suggestions'
                          ? 'border-blue-500 text-blue-600'
                          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                      }`}
                    >
                      <i className="ri-lightbulb-line"></i>
                      <span>Suggestions</span>
                    </button>
                    <button
                      onClick={() => setActiveTab('invoices')}
                      className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap flex items-center space-x-1 sm:space-x-2 ${
                        activeTab === 'invoices'
                          ? 'border-blue-500 text-blue-600'
                          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                      }`}
                    >
                      <i className="ri-bill-line"></i>
                      <span className="hidden sm:inline">Factures </span>
                      <span>Fournisseurs</span>
                    </button>
                    <button
                      onClick={() => setActiveTab('payments')}
                      className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap flex items-center space-x-1 sm:space-x-2 ${
                        activeTab === 'payments'
                          ? 'border-blue-500 text-blue-600'
                          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                      }`}
                    >
                      <i className="ri-calendar-check-line"></i>
                      <span>Échéances</span>
                    </button>
                  </nav>
                </div>
              </div>
            )}

            {/* Contenu principal */}
            {showInvoiceDetails && selectedInvoice ? (
              <InvoiceDetailsView 
                invoice={selectedInvoice}
                onClose={handleCloseInvoiceDetails}
                onEdit={handleEditInvoice}
                onAddPayment={handleAddPayment}
              />
            ) : showPaymentForm ? (
              <PaymentForm 
                invoice={selectedInvoiceForPayment}
                onClose={handleClosePaymentForm}
                onSave={handleSavePayment}
              />
            ) : showInvoiceForm ? (
              <SupplierInvoiceForm 
                invoice={editingInvoice}
                onClose={handleCloseInvoiceForm}
                onSave={handleSaveInvoice}
              />
            ) : showOrderDetails && selectedOrder ? (
              <OrderDetailsView 
                order={selectedOrder}
                onClose={handleCloseOrderDetails}
                onEdit={handleEditOrder}
                onReceive={handleReceiveOrder}
              />
            ) : showReceptionForm ? (
              <ReceptionForm 
                purchaseOrder={selectedOrderForReception}
                onClose={handleCloseReceptionForm}
                onSave={handleSaveReception}
              />
            ) : showOrderForm ? (
              <PurchaseOrderForm 
                order={editingOrder}
                onClose={handleCloseForm}
              />
            ) : (
              <>
                {activeTab === 'orders' && (
                  <PurchaseOrdersList 
                    onEdit={handleEditOrder}
                    onAdd={handleAddOrder}
                    onReceive={handleReceiveOrder}
                    onViewDetails={handleViewOrderDetails}
                  />
                )}
                {activeTab === 'receptions' && (
                  <ReceptionsList 
                    onViewDetails={handleViewReceptionDetails}
                  />
                )}
                {activeTab === 'suggestions' && (
                  <SuggestedOrders 
                    onCreateOrder={handleAddOrder}
                  />
                )}
                {activeTab === 'invoices' && (
                  <SupplierInvoicesList 
                    onViewDetails={handleViewInvoiceDetails}
                    onAddPayment={handleAddPayment}
                    onAddInvoice={handleAddInvoice}
                  />
                )}
                {activeTab === 'payments' && (
                  <PaymentDashboard 
                    onViewInvoice={handleViewInvoiceDetails}
                    onAddPayment={handleAddPayment}
                  />
                )}
              </>
            )}
          </div>
        </main>
      </div>
    </div>
  );
}

// Composant pour afficher les détails d'une commande

interface LigneCommande {
  id: string;
  produit: string;
  quantite: number;
  prix_unitaire_ht: number; // ou prixUnitaire selon ton API
}

interface PurchaseOrder {
  id: string;
  numero: string;
  fournisseur: string;
  date_commande: string;
  date_livraison_prevue: string | null;
  total_ttc: number;
  devise: string;
  statut:
    | 'Brouillon'
    | 'Envoyé'
    | 'En Cours (Partiel)'
    | 'Livrée'
    | 'Annulée'
    | 'Alerte';
  lignes: LigneCommande[];
  motif_annulation?: string;
}

interface OrderDetailsViewProps {
  order: PurchaseOrder;
  onClose: () => void;
  onEdit: (order: PurchaseOrder) => void;
  onReceive: (order: PurchaseOrder) => void;
}

const OrderDetailsView: React.FC<OrderDetailsViewProps> = ({
  order,
  onClose,
  onEdit,
  onReceive,
}) => {
  const formatAmount = (amount: number, devise: string) => {
    if (amount === 0) return '-';
    return new Intl.NumberFormat('fr-FR').format(amount) + ' ' + devise;
  };

  const formatDate = (dateString: string | null) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('fr-FR');
  };

  const getStatusColor = (statut: string) => {
    const colors: Record<string, string> = {
      'Brouillon': 'bg-gray-100 text-gray-800',
      'Envoyé': 'bg-blue-100 text-blue-800',
      'En Cours (Partiel)': 'bg-yellow-100 text-yellow-800',
      'Livrée': 'bg-green-100 text-green-800',
      'Annulée': 'bg-red-100 text-red-800',
      'Alerte': 'bg-orange-100 text-orange-800',
    };
    return colors[statut] || 'bg-gray-100 text-gray-800';
  };

  const getStatusIcon = (statut: string) => {
    const icons: Record<string, string> = {
      'Brouillon': 'ri-draft-line',
      'Envoyé': 'ri-send-plane-fill',
      'En Cours (Partiel)': 'ri-time-line',
      'Livrée': 'ri-checkbox-circle-fill',
      'Annulée': 'ri-close-circle-fill',
      'Alerte': 'ri-alarm-warning-fill',
    };
    return icons[statut] || 'ri-file-line';
  };

  const calculateTotal = () => {
    return order.lignes.reduce((sum, ligne) => sum + ligne.quantite * ligne.prix_unitaire_ht, 0);
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
      {/* En-tête */}
      <div className="p-6 border-b border-gray-200">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-4">
            <button
              onClick={onClose}
              className="flex items-center justify-center w-10 h-10 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
              title="Retour"
            >
              <i className="ri-arrow-left-line text-xl text-gray-600"></i>
            </button>
            <div>
              <h2 className="text-2xl font-bold text-gray-900">
                Bon de Commande {order.numero}
              </h2>
              <p className="text-sm text-gray-600 mt-1">Détails complets de la commande</p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            {order.statut === 'Brouillon' && (
              <button
                onClick={() => onEdit(order)}
                className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2.5 rounded-lg font-medium flex items-center gap-2 transition-colors"
              >
                <i className="ri-edit-line"></i>
                Modifier
              </button>
            )}
            {(order.statut === 'Envoyé' || 
              order.statut === 'En Cours (Partiel)' || 
              order.statut === 'Alerte') && (
              <button
                onClick={() => onReceive(order)}
                className="bg-orange-600 hover:bg-orange-700 text-white px-5 py-2.5 rounded-lg font-medium flex items-center gap-2 transition-colors"
              >
                <i className="ri-truck-line"></i>
                Réceptionner
              </button>
            )}
          </div>
        </div>

        {/* Statut */}
        <div className="flex flex-wrap items-center gap-3">
          <span className={`inline-flex items-center gap-2 px-3 py-1.5 text-sm font-semibold rounded-full ${getStatusColor(order.statut)}`}>
            <i className={getStatusIcon(order.statut)}></i>
            {order.statut}
          </span>
          {order.motif_annulation && (
            <span className="text-sm text-red-600 flex items-center gap-1">
              <i className="ri-information-line"></i>
              Motif : {order.motif_annulation}
            </span>
          )}
        </div>
      </div>

      {/* Informations générales */}
      <div className="p-6 border-b border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Informations Générales</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div>
            <label className="block text-sm font-medium text-gray-500 mb-1">Fournisseur</label>
            <p className="text-base font-semibold text-gray-900">{order.fournisseur}</p>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-500 mb-1">Date de Commande</label>
            <p className="text-base text-gray-900">{formatDate(order.date_commande)}</p>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-500 mb-1">Livraison Prévue</label>
            <p className="text-base text-gray-900">{formatDate(order.date_livraison_prevue)}</p>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-500 mb-1">Montant Total</label>
            <p className="text-base font-bold text-blue-600">
              {formatAmount(order.total_ttc, order.devise)}
            </p>
          </div>
        </div>
      </div>

      {/* Lignes de commande */}
      <div className="p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          Lignes de Commande ({order.lignes.length})
        </h3>

        {order.lignes.length > 0 ? (
          <div className="overflow-x-auto rounded-lg border border-gray-200">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Produit
                  </th>
                  <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Quantité
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Prix Unitaire
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Total Ligne
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {order.lignes.map((ligne) => (
                  <tr key={ligne.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 text-sm font-medium text-gray-900">
                      {ligne.produit}
                    </td>
                    <td className="px-6 py-4 text-center text-sm text-gray-900">
                      {ligne.quantite}
                    </td>
                    <td className="px-6 py-4 text-right text-sm text-gray-900">
                      {formatAmount(ligne.prix_unitaire_ht, order.devise)}
                    </td>
                    <td className="px-6 py-4 text-right text-sm font-semibold text-gray-900">
                      {formatAmount(ligne.quantite * ligne.prix_unitaire_ht, order.devise)}
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot className="bg-gray-50 font-medium">
                <tr>
                  <td colSpan={3} className="px-6 py-4 text-right text-base">
                    Total Général
                  </td>
                  <td className="px-6 py-4 text-right text-lg font-bold text-blue-600">
                    {formatAmount(calculateTotal(), order.devise)}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        ) : (
          <div className="text-center py-16 bg-gray-50 rounded-lg">
            <i className="ri-inbox-line text-5xl text-gray-300 mb-4"></i>
            <p className="text-gray-500">Aucune ligne de commande</p>
          </div>
        )}
      </div>

      {/* Alerte de retard */}
      {order.statut === 'Alerte' && (
        <div className="p-6 bg-orange-50 border-t-4 border-orange-400">
          <div className="flex items-start gap-4">
            <i className="ri-alarm-warning-fill text-3xl text-orange-600 mt-1"></i>
            <div>
              <h4 className="font-semibold text-orange-900">Alerte de retard détectée</h4>
              <p className="text-sm text-orange-800 mt-1">
                La date de livraison prévue du <strong>{formatDate(order.date_livraison_prevue)}</strong> est dépassée.
                Contactez le fournisseur pour plus d'informations.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Composant pour afficher les détails d'une facture fournisseur
function InvoiceDetailsView({ invoice, onClose, onEdit, onAddPayment }: any) {
  const formatAmount = (amount: number) => {
    if (!amount || amount === 0) return '-';
    return new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 0 }).format(amount) + ' GNF';
  };

  const formatDate = (dateString: string | null) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('fr-FR');
  };

  const getStatusColor = (statut: string) => {
    switch (statut) {
      case 'PAYEE': return 'bg-green-100 text-green-800';
      case 'PAYEE_PARTIEL': return 'bg-orange-100 text-orange-800';
      case 'IMPAYEE': return 'bg-yellow-100 text-yellow-800';
      case 'ANNULEE': return 'bg-red-100 text-red-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  const getStatusIcon = (statut: string) => {
    switch (statut) {
      case 'PAYEE': return 'ri-checkbox-circle-fill';
      case 'PAYEE_PARTIEL': return 'ri-progress-3-line';
      case 'IMPAYEE': return 'ri-time-line';
      case 'ANNULEE': return 'ri-close-circle-fill';
      default: return 'ri-file-line';
    }
  };

  // Nouveau : on calcule le montant payé via la pivot (plus fiable que montant_paye)
  const montantPayeViaPivot = invoice.bonsReception?.reduce((sum: number, br: any) => {
    return sum + (br.pivot?.montant_affecte || 0);
  }, 0) || 0;

  const resteAPayer = invoice.total_ttc - invoice.montant_paye;

  const isOverdue = () => {
    if (!invoice.date_echeance || invoice.statut_paiement === 'PAYEE') return false;
    return new Date(invoice.date_echeance) < new Date();
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
      {/* En-tête */}
      <div className="p-6 border-b border-gray-200">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-4">
            <button
              onClick={onClose}
              className="w-10 h-10 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
              title="Retour"
            >
              <i className="ri-arrow-left-line text-xl"></i>
            </button>
            <div>
              <h2 className="text-2xl font-bold text-gray-900">
                Facture {invoice.numero_facture_fournisseur}
              </h2>
              <p className="text-sm text-gray-600 mt-1">
                Fournisseur : <strong>{invoice.fournisseur.raison_sociale}</strong>
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            {invoice.statut_paiement !== 'PAYEE' || invoice.statut_paiement !== 'PAYEE_PARTIEL' && (
              <>
                <button
                  onClick={() => onEdit(invoice)}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-700 text-white px-5 py-2.5 rounded-lg font-medium flex items-center gap-2"
                >
                  <i className="ri-edit-line"></i> Modifier
                </button>
              </>
            )}
            {invoice.statut_paiement !== 'PAYEE' && (
              <>
                <button
                  onClick={() => onAddPayment(invoice)}
                  className="bg-green-600 hover:bg-green-700 text-white px-5 py-2.5 rounded-lg font-medium flex items-center gap-2"
                >
                  <i className="ri-money-euro-circle-line"></i> Régler
                </button>
              </>
            )}
          </div>
        </div>

      </div>

        {/* Statut principal */}
        <div className="flex items-center gap-3">
          <span className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-bold ${getStatusColor(invoice.statut_paiement)}`}>
            <i className={getStatusIcon(invoice.statut_paiement)}></i>
            {invoice.statut_paiement_label || invoice.statut_paiement}
          </span>
          {isOverdue() && (
            <span className="inline-flex items-center gap-1 px-3 py-600 text-red-800 rounded-full text-xs font-bold">
              <i className="ri-alarm-warning-fill"></i> En retard
            </span>
          )}
        </div>

      {/* Informations générales */}
      <div className="p-6 border-b border-gray-200">
        <h3 className="text-lg font-semibold mb-4">Informations Générales</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div>
            <label className="text-sm text-gray-500">Date facture</label>
            <p className="font-semibold">{formatDate(invoice.date_facture)}</p>
          </div>
          <div>
            <label className="text-sm text-gray-500">Date échéance</label>
            <p className={`font-semibold ${isOverdue() ? 'text-red-600' : ''}`}>
              {formatDate(invoice.date_echeance)}
            </p>
          </div>
          <div>
            <label className="text-sm text-gray-500">Total TTC</label>
            <p className="text-xl font-bold text-blue-600">{formatAmount(invoice.total_ttc)}</p>
          </div>
          <div>
            <label className="text-sm text-gray-500">Reste à payer</label>
            <p className={`text-xl font-bold ${resteAPayer > 0 ? 'text-red-600' : 'text-green-600'}`}>
              {formatAmount(resteAPayer)}
            </p>
          </div>
        </div>
      </div>

      {/* Bons de réception rattachés */}
      <div className="p-6 border-b border-gray-200">
        <h3 className="text-lg font-semibold mb-4">
          Bons de Réception Rattachés ({invoice.bonsReception?.length || 0})
        </h3>
        {invoice.bonsReception && invoice.bonsReception.length > 0 ? (
          <div className="space-y-3">
            {invoice.bonsReception.map((br: any) => {
              const brPaye = invoice.bonsReception?.find((b: any) => b.id === br.id)?.pivot?.montant_affecte || 0;
              const brRestant = br.montant_total - br.montant_paye; // ou montant_restant si tu l’as

              return (
                <div key={br.id} className="bg-gray-50 p-4 rounded-lg border">
                  <div className="flex justify-between items-center">
                    <div>
                      <span className="font-semibold">{br.numero}</span>
                      <span className="text-sm text-gray-600 ml-3">
                        Total BR : {formatAmount(br.montant_total || br.montant_restant + br.montant_paye)}
                      </span>
                    </div>
                    <div className="text-right">
                      <div className="text-sm text-gray-600">Payé sur ce BR</div>
                      <div className="text-lg font-bold text-green-600">
                        {formatAmount(br.montant_paye)}
                      </div>
                      {brRestant <= 0 ? (
                        <span className="inline-block mt-1 px-3 py-1 bg-green-100 text-green-800 rounded text-xs font-bold">
                          Soldé
                        </span>
                      ) : (
                        <div className="text-sm text-orange-600">
                          Reste : {formatAmount(brRestant)}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <p className="text-gray-500 text-center py-8">Aucun BR rattaché</p>
        )}
      </div>

      {/* Historique des règlements */}
      <div className="p-6">
        <h3 className="text-lg font-semibold mb-4">
          Historique des Règlements ({invoice.paiements?.length || 0})
        </h3>
        {invoice.paiements && invoice.paiements.length > 0 ? (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Mode</th>
                  <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Montant</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {invoice.paiements.map((p: any) => (
                  <tr key={p.id} className="hover:bg-gray-50">
                    <td className="px-4 py-4 text-sm">{formatDate(p.date_paiement)}</td>
                    <td className="px-4 py-4 text-sm">{p.mode}</td>
                    <td className="px-4 py-4 text-right text-sm font-semibold text-green-600">
                      {formatAmount(p.montant)}
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot className="bg-gray-50 font-medium">
                <tr>
                  <td colSpan={2} className="px-4 py-4 text-right text-base font-bold">
                    Total réglé :
                  </td>
                  <td className="px-4 py-4 text-right text-lg font-bold text-green-600">
                    {formatAmount(invoice.total_regle)}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        ) : (
          <div className="text-center py-12 bg-gray-50 rounded-lg">
            <i className="ri-money-euro-circle-line text-5xl text-gray-300 mb-4"></i>
            <p className="text-gray-500">Aucun règlement enregistré</p>
            {invoice.statut_paiement !== 'PAYEE' && (
              <button
                onClick={() => onAddPayment(invoice)}
                className="mt-4 bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg font-medium"
              >
                Ajouter un règlement
              </button>
            )}
          </div>
        )}
      </div>


      {/* Alerte de retard */}
      {isOverdue() && (
        <div className="p-6 bg-red-50 border-t-4 border-red-500">
          <div className="flex items-center gap-3">
            <i className="ri-alarm-warning-fill text-3xl text-red-600"></i>
            <div>
              <h4 className="font-bold text-red-900">Facture en retard</h4>
              <p className="text-red-800">
                Échéance dépassée de {Math.abs(invoice.jours_avant_echeance || 0)} jour(s)
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}